import { IDefineCommand, ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { SectionFiltersModel } from '../models/section_filters_model';

export type GetSectionFiltersCommand = (termId: number, courseId: number, sectionType: number) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'getSectionFiltersCommand',
    (
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngSectionFiltersModel: SectionFiltersModel,
      log: any
    ): ICommand => {
      return defineCommandORM(
        'getSectionFiltersCommand',
        (
          deferred: ng.IDeferred<IQuery[]>,
          termId: number,
          courseId: number,
          sectionType: number
        ): ng.IPromise<void> => {
          return $http
            .get(`/cat/sections/term/${termId}/course/${courseId}/section_type/${sectionType}/schedule_filter`)
            .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
              ngSectionFiltersModel.clear().write(data);
              deferred.resolve();
            })
            .catch((e) => {
              log.issue('Failed to get section filters');
              deferred.reject(e);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_filters/commands/get_section_filters_command.ts